import { j as r } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as u } from "react";
import p from "./TableBulkActions/TableBulkActions.js";
import b from "./TableDefaultControls/TableDefaultControls.js";
const c = ({
  actions: s,
  selected: t,
  total: e,
  onFullScreenClick: n,
  onDensityChange: a,
  onColumnDisplay: f,
  onColumnSort: m,
  ...i
}) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    className: "mb-200 text-nowrap",
    "data-testid": "table-default-controls",
    children: [
      Number(t) > 0 && /* @__PURE__ */ r.jsx(
        p,
        {
          actions: s,
          selected: t,
          total: e
        }
      ),
      (!t || Number(t) <= 0) && /* @__PURE__ */ r.jsx(
        b,
        {
          ...i,
          ...typeof n == "function" && {
            onFullScreenClick: () => n()
          },
          ...typeof a == "function" && {
            onDensityChange: (o) => a(o)
          },
          ...typeof f == "function" && {
            onColumnDisplay: (o, l) => f(o, l)
          },
          ...typeof m == "function" && {
            onColumnSort: (o) => m(o)
          }
        }
      )
    ]
  }
), d = u(c);
export {
  d as default
};
//# sourceMappingURL=TableControls.js.map
